// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#dash-home[data-v-74468141]{grid-row:3/4;grid-column:2/3;width:calc(100vw - 250px);height:82vh;overflow:auto;min-width:475px;display:flex;flex-flow:column;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
